export default __webpack_public_path__ + "static/media/icon-arrow-back-color-primary.4d112533.svg";